<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title v-if="mock">{{ mock.full_name }} <br> {{ mock.short_name }}</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs centered class="blur">
          <v-tab :to="{name: 'Mock edit', params: $route.params}">Base settings</v-tab>
          <v-tab :to="{name: 'Mock scenario', params: $route.params}">Scenario</v-tab>
          <v-tab :to="{name: 'Mock marksheet', params: $route.params}">Marksheet</v-tab>
          <v-tab :to="{name: 'Mock instructions', params: $route.params}">Instructions</v-tab>
          <v-tab :to="{name: 'Mock materials', params: $route.params}">Materials</v-tab>
          <v-tab :to="{name: 'Mock extra tasks', params: $route.params}">Extra tasks</v-tab>
          <v-tab :to="{name: 'Mock answer templates', params: $route.params}">Answer templates</v-tab>
          <v-tab :to="{name: 'Mock reviews', params: $route.params}">Reviews</v-tab>
          <template v-if="mock && mock.children && mock.children.length > 0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-tab v-bind="attrs" v-on="on">Children mocks</v-tab>
              </template>
              <v-list>
                <v-list-item v-for="(item, idx) in mock.children" :key="idx"
                             :to="{name: 'Mock', params: {mock_id: item.id}}" target="_blank">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-tabs>
      </template>
    </v-toolbar>

    <router-view :mocks="mocks" :mock="mock" @loadMock="loadMock"/>
  </section>
</template>

<script>

export default {
  data: () => ({
    mocks: [],
    mock: null,
  }),
  created() {
    this.loadMock()
    this.loadMocks()
  },
  methods: {
    async loadMocks() {
      this.mocks = await this.axios.get(`api/mocks`).then(({data}) => data.data)
    },
    async loadMock() {
      this.mock = await this.axios.get(`api/mocks/${this.$route.params.mock_id}`)
          .then(({data}) => data.data)
          .catch(errors => {
            if(errors.response.status === 404) this.$router.push({name: "E404"})
          })
    },
  }
}
</script>